module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iNNC6"))).then(() => parcelRequire('hEqeo'));